// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimeItem-module__font-s-10___fj69D {
  font-size: 10px !important;
}

.TimeItem-module__font-s-12___wtwp8 {
  font-size: 12px !important;
}

.TimeItem-module__font-s-13___vcKkO {
  font-size: 13px !important;
}

.TimeItem-module__font-s-14___K4085 {
  font-size: 14px !important;
}

.TimeItem-module__font-s-15___wxVLq {
  font-size: 15px !important;
}

.TimeItem-module__font-s-16___htpeq {
  font-size: 16px !important;
}

.TimeItem-module__font-s-18___kBT2o {
  font-size: 18px !important;
}

.TimeItem-module__font-s-20___yArvF {
  font-size: 20px !important;
}

.TimeItem-module__font-s-22___TCPAZ {
  font-size: 22px !important;
}

.TimeItem-module__font-s-28___imiBD {
  font-size: 28px !important;
}

.TimeItem-module__font-w-400___KKeo5 {
  font-weight: 400 !important;
}

.TimeItem-module__font-w-500___bdXfd {
  font-weight: 500 !important;
}

.TimeItem-module__font-w-600___o1Ob0 {
  font-weight: 600 !important;
}

.TimeItem-module__font-w-700___Af3Fl {
  font-weight: 700 !important;
}

.TimeItem-module__p-5___aQNw1 {
  padding: 5px !important;
}

.TimeItem-module__p-12___B1vRo {
  padding: 12px !important;
}

.TimeItem-module__p-16___Pq0Zi {
  padding: 16px !important;
}

.TimeItem-module__p-30___Ydy3n {
  padding: 30px !important;
}

.TimeItem-module__p-b-0___twRMU {
  padding-bottom: 0 !important;
}

.TimeItem-module__p-b-5___WG2oL {
  padding-bottom: 5px !important;
}

.TimeItem-module__p-b-10___wIYmF {
  padding-bottom: 10px !important;
}

.TimeItem-module__p-b-12___qEhZN {
  padding-bottom: 12px !important;
}

.TimeItem-module__p-b-16___pSold {
  padding-bottom: 16px !important;
}

.TimeItem-module__p-b-18___uetAt {
  padding-bottom: 18px !important;
}

.TimeItem-module__p-b-20___yHXVR {
  padding-bottom: 20px !important;
}

.TimeItem-module__p-b-25___VuHaz {
  padding-bottom: 25px !important;
}

.TimeItem-module__p-b-30___fHJDJ {
  padding-bottom: 30px !important;
}

.TimeItem-module__p-b-50___ac62g {
  padding-bottom: 50px !important;
}

.TimeItem-module__p-t-0___vo7Wm {
  padding-top: 0 !important;
}

.TimeItem-module__p-t-12___b7Hw0 {
  padding-top: 12px !important;
}

.TimeItem-module__p-t-16___Hxhqx {
  padding-top: 16px !important;
}

.TimeItem-module__p-t-18___mHhvP {
  padding-top: 18px !important;
}

.TimeItem-module__p-t-20___YVLLb {
  padding-top: 20px !important;
}

.TimeItem-module__p-t-30____mZuT {
  padding-top: 30px !important;
}

.TimeItem-module__p-t-40___WlIiZ {
  padding-top: 40px !important;
}

.TimeItem-module__p-t-50___N4MJM {
  padding-top: 50px !important;
}

.TimeItem-module__p-l-20___PebgY {
  padding-left: 20px !important;
}

.TimeItem-module__p-l-30___H886t {
  padding-left: 30px !important;
}

.TimeItem-module__p-l-40___dLoFl {
  padding-left: 40px !important;
}

.TimeItem-module__p-r-16___TBuxc {
  padding-right: 16px !important;
}

.TimeItem-module__p-r-20___J7_zK {
  padding-right: 20px !important;
}

.TimeItem-module__p-r-30___YV7U3 {
  padding-right: 30px !important;
}

.TimeItem-module__p-r-50___yKhFm {
  padding-right: 50px !important;
}

.TimeItem-module__p-r-60___H_ABC {
  padding-right: 60px !important;
}

.TimeItem-module__m-b-1___qH1Pu {
  margin-bottom: 1px !important;
}

.TimeItem-module__m-b-2___NM6ak {
  margin-bottom: 2px !important;
}

.TimeItem-module__m-b-6___fRUXw {
  margin-bottom: 6px !important;
}

.TimeItem-module__m-b-8___P_mNQ {
  margin-bottom: 8px !important;
}

.TimeItem-module__m-b-10___fTuAS {
  margin-bottom: 10px !important;
}

.TimeItem-module__m-b-14___O8d1n {
  margin-bottom: 14px !important;
}

.TimeItem-module__m-b-16___dbBlf {
  margin-bottom: 16px !important;
}

.TimeItem-module__m-b-20___hH9b5 {
  margin-bottom: 20px !important;
}

.TimeItem-module__m-b-22___rRFzm {
  margin-bottom: 22px !important;
}

.TimeItem-module__m-b-24___vOOIq {
  margin-bottom: 24px !important;
}

.TimeItem-module__m-b-30___QqcWI {
  margin-bottom: 30px !important;
}

.TimeItem-module__m-b-32___RbDE6 {
  margin-bottom: 32px !important;
}

.TimeItem-module__m-b-40___NI8pN {
  margin-bottom: 40px !important;
}

.TimeItem-module__m-t-2___icpsS {
  margin-top: 2px !important;
}

.TimeItem-module__m-t-3___ifYKX {
  margin-top: 3px !important;
}

.TimeItem-module__m-t-4___GWa1j {
  margin-top: 4px !important;
}

.TimeItem-module__m-t-5___aZVkB {
  margin-top: 5px !important;
}

.TimeItem-module__m-t-8___sVwND {
  margin-top: 8px !important;
}

.TimeItem-module__m-t-10___flbRi {
  margin-top: 10px !important;
}

.TimeItem-module__m-t-15___PViI5 {
  margin-top: 15px !important;
}

.TimeItem-module__m-t-16___wVG6e {
  margin-top: 16px !important;
}

.TimeItem-module__m-t-20___XgWUF {
  margin-top: 20px !important;
}

.TimeItem-module__m-t-22___YYYsP {
  margin-top: 22px !important;
}

.TimeItem-module__m-t-30___yZk7Q {
  margin-top: 30px !important;
}

.TimeItem-module__m-t-32___PTCiL {
  margin-top: 32px !important;
}

.TimeItem-module__m-l-auto___yOVik {
  margin-left: auto !important;
}

.TimeItem-module__m-l-4___VTMud {
  margin-left: 4px !important;
}

.TimeItem-module__m-l-5___ab3An {
  margin-left: 5px !important;
}

.TimeItem-module__m-l-6___rXh1g {
  margin-left: 6px !important;
}

.TimeItem-module__m-l-8___yEzY2 {
  margin-left: 8px !important;
}

.TimeItem-module__m-l-10___ckyGa {
  margin-left: 10px !important;
}

.TimeItem-module__m-l-16___jExA1 {
  margin-left: 16px !important;
}

.TimeItem-module__m-l-20___m8wKB {
  margin-left: 20px !important;
}

.TimeItem-module__m-l-24___l92RJ {
  margin-left: 24px !important;
}

.TimeItem-module__m-l-30___cpzY6 {
  margin-left: 30px !important;
}

.TimeItem-module__m-l-35___sxWHg {
  margin-left: 35px !important;
}

.TimeItem-module__m-l-40___8zizn {
  margin-left: 40px !important;
}

.TimeItem-module__m-r-8___FrjL5 {
  margin-right: 8px !important;
}

.TimeItem-module__m-r-10___Tpthr {
  margin-right: 10px !important;
}

.TimeItem-module__m-r-16___rJc7A {
  margin-right: 16px !important;
}

.TimeItem-module__m-r-20___WMdrh {
  margin-right: 20px !important;
}

.TimeItem-module__m-r-24___mqfib {
  margin-right: 24px !important;
}

.TimeItem-module__m-r-30___N5iGM {
  margin-right: 30px !important;
}

.TimeItem-module__m-r-40___dU_Tc {
  margin-right: 40px !important;
}

.TimeItem-module__border-r-3___A2j8V {
  border-radius: 3px !important;
}

.TimeItem-module__border-r-4___l8lwj {
  border-radius: 4px !important;
}

.TimeItem-module__border-r-6___iixUH {
  border-radius: 6px !important;
}

.TimeItem-module__border-r-10___sBpEg {
  border-radius: 10px !important;
}

.TimeItem-module__border-r-12___Y95ev {
  border-radius: 12px !important;
}

.TimeItem-module__border-r-16___lQPoS {
  border-radius: 16px !important;
}

.TimeItem-module__border-r-50___v2QqG {
  border-radius: 50% !important;
}

.TimeItem-module__primary-border___mgcjD {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TimeItem-module__primary-border-b___wr53J {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TimeItem-module__primary-border-t___ehreT {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TimeItem-module__primary-border-l___jLS7u {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TimeItem-module__primary-border-r___WTOIC {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TimeItem-module__secondary-border___poU6x {
  border: 1px solid #637768;
}

.TimeItem-module__secondary-border-b___pIOYe {
  border-bottom: 1px solid #637768;
}

.TimeItem-module__secondary-border-t___FOFrK {
  border-top: 1px solid #637768;
}

.TimeItem-module__secondary-border-l___Zl0XC {
  border-left: 1px solid #637768;
}

.TimeItem-module__secondary-border-r___iNSgP {
  border-right: 1px solid #637768;
}

.TimeItem-module__gap-0___mabZt {
  gap: 0 !important;
}

.TimeItem-module__gap-2___ENYeq {
  gap: 2px !important;
}

.TimeItem-module__gap-4___x0sPd {
  gap: 4px !important;
}

.TimeItem-module__gap-5___q498q {
  gap: 5px !important;
}

.TimeItem-module__gap-6___NI55u {
  gap: 6px !important;
}

.TimeItem-module__gap-8___toLN6 {
  gap: 8px !important;
}

.TimeItem-module__gap-10___HvVWi {
  gap: 10px !important;
}

.TimeItem-module__gap-12___kop3T {
  gap: 12px !important;
}

.TimeItem-module__gap-14___Vbg3e {
  gap: 14px !important;
}

.TimeItem-module__gap-16___vG0oq {
  gap: 16px !important;
}

.TimeItem-module__gap-18___QZQkA {
  gap: 18px !important;
}

.TimeItem-module__gap-20___kFfK7 {
  gap: 20px !important;
}

.TimeItem-module__gap-24___PjG3L {
  gap: 24px !important;
}

.TimeItem-module__gap-26___M80oc {
  gap: 26px !important;
}

.TimeItem-module__gap-30___xYoE5 {
  gap: 30px !important;
}

.TimeItem-module__gap-32___mlyGe {
  gap: 32px !important;
}

.TimeItem-module__gap-40___vhQIH {
  gap: 40px !important;
}

.TimeItem-module__gap-50___qzg4r {
  gap: 50px !important;
}

.TimeItem-module__flex-1___XWyMH {
  flex: 1;
}

.TimeItem-module__flex-none___Ig1o4 {
  flex: none !important;
}

.TimeItem-module__flex-column___yO3zF {
  display: flex;
  flex-direction: column !important;
}

.TimeItem-module__flex-row___qeOxO {
  display: flex;
  flex-direction: row !important;
}

.TimeItem-module__vertically-centered___VOVh2 {
  display: flex;
  align-items: center !important;
}

.TimeItem-module__horizontally-centered___hQpfl {
  display: flex;
  justify-content: center !important;
}

.TimeItem-module__horizontally-end___NjbkR {
  display: flex;
  justify-content: end !important;
}

.TimeItem-module__vertically-start___o5RVb {
  display: flex;
  align-items: start !important;
}

.TimeItem-module__space-between___HOZhw {
  display: flex;
  justify-content: space-between !important;
}

.TimeItem-module__flex-wrap___d949x {
  flex-wrap: wrap !important;
}

.TimeItem-module__height-100___i7P0v {
  height: 100%;
}

.TimeItem-module__width-50___xuR_X {
  width: 50% !important;
}

.TimeItem-module__width-100___QWRQA {
  width: 100%;
}

.TimeItem-module__cursor-pointer___ZxN7G {
  cursor: pointer;
}

.TimeItem-module__cursor-not-allowed____vS1X {
  cursor: not-allowed !important;
}

.TimeItem-module__absolute-centered___BR3Ki {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TimeItem-module__absolute___jUZ9D {
  position: absolute;
}

.TimeItem-module__relative___wiuzv {
  position: relative;
}

.TimeItem-module__fixed___wt1Gl {
  position: fixed;
}

.TimeItem-module__visible___N2vT8 {
  opacity: 1;
}

.TimeItem-module__invisible___ecICf {
  opacity: 0;
}

.TimeItem-module__col-90___UEDpv {
  width: 90% !important;
}

.TimeItem-module__col-auto___m8jK9 {
  width: auto !important;
}

.TimeItem-module__medical-tabs___qJuf_ {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TimeItem-module__medical-table-new___y52OW {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TimeItem-module__medical-table-new___y52OW:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TimeItem-module__medical-table-new___y52OW::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TimeItem-module__medical-table-new___y52OW::-webkit-scrollbar-track {
  display: none;
}
.TimeItem-module__medical-table-new___y52OW.TimeItem-module__no-pagination___Z2QSG {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TimeItem-module__medical-table-new___y52OW.TimeItem-module__no-pagination___Z2QSG:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TimeItem-module__medical-table-new___y52OW.TimeItem-module__no-pagination___Z2QSG::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TimeItem-module__medical-table-new___y52OW.TimeItem-module__no-pagination___Z2QSG::-webkit-scrollbar-track {
  display: none;
}

.TimeItem-module__medical-table-empty____9rhD {
  padding: 14px 40px !important;
}

.TimeItem-module__icon-btn___juRGO {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TimeItem-module__search-icon___iUnA3 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TimeItem-module__disable-select___GoakN {
  user-select: none;
}

.TimeItem-module__break-word___TwsAU {
  word-break: break-word;
}

.TimeItem-module__popup-clear-btn___A9WBe {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TimeItem-module__scroll-m-b-20___A6jF3 {
  scroll-margin-bottom: 20px;
}

.TimeItem-module__container___eeVyg {
  padding: 0 10px;
  /* remove arrows for input type number */
}
.TimeItem-module__container___eeVyg .TimeItem-module__input___VQQez {
  color: #375844;
  border: none;
  font-weight: bold;
  text-align: center;
  width: 20px !important;
}
.TimeItem-module__container___eeVyg input::-webkit-outer-spin-button,
.TimeItem-module__container___eeVyg input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.TimeItem-module__container___eeVyg input[type=number] {
  -moz-appearance: textfield;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/DatePickerNew/inputs/TimeInput/TimeItem/TimeItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,eAAA;EAUA,wCAAA;AAqpBF;AA7pBE;EACE,cAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AA+pBJ;AA3pBE;;EAEE,wBAAA;EACA,SAAA;AA6pBJ;AA1pBE;EACE,0BAAA;AA4pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  padding: 0 10px;\n\n  .input {\n    color: get-color(greenNew, dark);\n    border: none;\n    font-weight: bold;\n    text-align: center;\n    width: 20px !important;\n  }\n\n  /* remove arrows for input type number */\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  input[type='number'] {\n    -moz-appearance: textfield;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TimeItem-module__font-s-10___fj69D`,
	"fontS12": `TimeItem-module__font-s-12___wtwp8`,
	"fontS13": `TimeItem-module__font-s-13___vcKkO`,
	"fontS14": `TimeItem-module__font-s-14___K4085`,
	"fontS15": `TimeItem-module__font-s-15___wxVLq`,
	"fontS16": `TimeItem-module__font-s-16___htpeq`,
	"fontS18": `TimeItem-module__font-s-18___kBT2o`,
	"fontS20": `TimeItem-module__font-s-20___yArvF`,
	"fontS22": `TimeItem-module__font-s-22___TCPAZ`,
	"fontS28": `TimeItem-module__font-s-28___imiBD`,
	"fontW400": `TimeItem-module__font-w-400___KKeo5`,
	"fontW500": `TimeItem-module__font-w-500___bdXfd`,
	"fontW600": `TimeItem-module__font-w-600___o1Ob0`,
	"fontW700": `TimeItem-module__font-w-700___Af3Fl`,
	"p5": `TimeItem-module__p-5___aQNw1`,
	"p12": `TimeItem-module__p-12___B1vRo`,
	"p16": `TimeItem-module__p-16___Pq0Zi`,
	"p30": `TimeItem-module__p-30___Ydy3n`,
	"pB0": `TimeItem-module__p-b-0___twRMU`,
	"pB5": `TimeItem-module__p-b-5___WG2oL`,
	"pB10": `TimeItem-module__p-b-10___wIYmF`,
	"pB12": `TimeItem-module__p-b-12___qEhZN`,
	"pB16": `TimeItem-module__p-b-16___pSold`,
	"pB18": `TimeItem-module__p-b-18___uetAt`,
	"pB20": `TimeItem-module__p-b-20___yHXVR`,
	"pB25": `TimeItem-module__p-b-25___VuHaz`,
	"pB30": `TimeItem-module__p-b-30___fHJDJ`,
	"pB50": `TimeItem-module__p-b-50___ac62g`,
	"pT0": `TimeItem-module__p-t-0___vo7Wm`,
	"pT12": `TimeItem-module__p-t-12___b7Hw0`,
	"pT16": `TimeItem-module__p-t-16___Hxhqx`,
	"pT18": `TimeItem-module__p-t-18___mHhvP`,
	"pT20": `TimeItem-module__p-t-20___YVLLb`,
	"pT30": `TimeItem-module__p-t-30____mZuT`,
	"pT40": `TimeItem-module__p-t-40___WlIiZ`,
	"pT50": `TimeItem-module__p-t-50___N4MJM`,
	"pL20": `TimeItem-module__p-l-20___PebgY`,
	"pL30": `TimeItem-module__p-l-30___H886t`,
	"pL40": `TimeItem-module__p-l-40___dLoFl`,
	"pR16": `TimeItem-module__p-r-16___TBuxc`,
	"pR20": `TimeItem-module__p-r-20___J7_zK`,
	"pR30": `TimeItem-module__p-r-30___YV7U3`,
	"pR50": `TimeItem-module__p-r-50___yKhFm`,
	"pR60": `TimeItem-module__p-r-60___H_ABC`,
	"mB1": `TimeItem-module__m-b-1___qH1Pu`,
	"mB2": `TimeItem-module__m-b-2___NM6ak`,
	"mB6": `TimeItem-module__m-b-6___fRUXw`,
	"mB8": `TimeItem-module__m-b-8___P_mNQ`,
	"mB10": `TimeItem-module__m-b-10___fTuAS`,
	"mB14": `TimeItem-module__m-b-14___O8d1n`,
	"mB16": `TimeItem-module__m-b-16___dbBlf`,
	"mB20": `TimeItem-module__m-b-20___hH9b5`,
	"mB22": `TimeItem-module__m-b-22___rRFzm`,
	"mB24": `TimeItem-module__m-b-24___vOOIq`,
	"mB30": `TimeItem-module__m-b-30___QqcWI`,
	"mB32": `TimeItem-module__m-b-32___RbDE6`,
	"mB40": `TimeItem-module__m-b-40___NI8pN`,
	"mT2": `TimeItem-module__m-t-2___icpsS`,
	"mT3": `TimeItem-module__m-t-3___ifYKX`,
	"mT4": `TimeItem-module__m-t-4___GWa1j`,
	"mT5": `TimeItem-module__m-t-5___aZVkB`,
	"mT8": `TimeItem-module__m-t-8___sVwND`,
	"mT10": `TimeItem-module__m-t-10___flbRi`,
	"mT15": `TimeItem-module__m-t-15___PViI5`,
	"mT16": `TimeItem-module__m-t-16___wVG6e`,
	"mT20": `TimeItem-module__m-t-20___XgWUF`,
	"mT22": `TimeItem-module__m-t-22___YYYsP`,
	"mT30": `TimeItem-module__m-t-30___yZk7Q`,
	"mT32": `TimeItem-module__m-t-32___PTCiL`,
	"mLAuto": `TimeItem-module__m-l-auto___yOVik`,
	"mL4": `TimeItem-module__m-l-4___VTMud`,
	"mL5": `TimeItem-module__m-l-5___ab3An`,
	"mL6": `TimeItem-module__m-l-6___rXh1g`,
	"mL8": `TimeItem-module__m-l-8___yEzY2`,
	"mL10": `TimeItem-module__m-l-10___ckyGa`,
	"mL16": `TimeItem-module__m-l-16___jExA1`,
	"mL20": `TimeItem-module__m-l-20___m8wKB`,
	"mL24": `TimeItem-module__m-l-24___l92RJ`,
	"mL30": `TimeItem-module__m-l-30___cpzY6`,
	"mL35": `TimeItem-module__m-l-35___sxWHg`,
	"mL40": `TimeItem-module__m-l-40___8zizn`,
	"mR8": `TimeItem-module__m-r-8___FrjL5`,
	"mR10": `TimeItem-module__m-r-10___Tpthr`,
	"mR16": `TimeItem-module__m-r-16___rJc7A`,
	"mR20": `TimeItem-module__m-r-20___WMdrh`,
	"mR24": `TimeItem-module__m-r-24___mqfib`,
	"mR30": `TimeItem-module__m-r-30___N5iGM`,
	"mR40": `TimeItem-module__m-r-40___dU_Tc`,
	"borderR3": `TimeItem-module__border-r-3___A2j8V`,
	"borderR4": `TimeItem-module__border-r-4___l8lwj`,
	"borderR6": `TimeItem-module__border-r-6___iixUH`,
	"borderR10": `TimeItem-module__border-r-10___sBpEg`,
	"borderR12": `TimeItem-module__border-r-12___Y95ev`,
	"borderR16": `TimeItem-module__border-r-16___lQPoS`,
	"borderR50": `TimeItem-module__border-r-50___v2QqG`,
	"primaryBorder": `TimeItem-module__primary-border___mgcjD`,
	"primaryBorderB": `TimeItem-module__primary-border-b___wr53J`,
	"primaryBorderT": `TimeItem-module__primary-border-t___ehreT`,
	"primaryBorderL": `TimeItem-module__primary-border-l___jLS7u`,
	"primaryBorderR": `TimeItem-module__primary-border-r___WTOIC`,
	"secondaryBorder": `TimeItem-module__secondary-border___poU6x`,
	"secondaryBorderB": `TimeItem-module__secondary-border-b___pIOYe`,
	"secondaryBorderT": `TimeItem-module__secondary-border-t___FOFrK`,
	"secondaryBorderL": `TimeItem-module__secondary-border-l___Zl0XC`,
	"secondaryBorderR": `TimeItem-module__secondary-border-r___iNSgP`,
	"gap0": `TimeItem-module__gap-0___mabZt`,
	"gap2": `TimeItem-module__gap-2___ENYeq`,
	"gap4": `TimeItem-module__gap-4___x0sPd`,
	"gap5": `TimeItem-module__gap-5___q498q`,
	"gap6": `TimeItem-module__gap-6___NI55u`,
	"gap8": `TimeItem-module__gap-8___toLN6`,
	"gap10": `TimeItem-module__gap-10___HvVWi`,
	"gap12": `TimeItem-module__gap-12___kop3T`,
	"gap14": `TimeItem-module__gap-14___Vbg3e`,
	"gap16": `TimeItem-module__gap-16___vG0oq`,
	"gap18": `TimeItem-module__gap-18___QZQkA`,
	"gap20": `TimeItem-module__gap-20___kFfK7`,
	"gap24": `TimeItem-module__gap-24___PjG3L`,
	"gap26": `TimeItem-module__gap-26___M80oc`,
	"gap30": `TimeItem-module__gap-30___xYoE5`,
	"gap32": `TimeItem-module__gap-32___mlyGe`,
	"gap40": `TimeItem-module__gap-40___vhQIH`,
	"gap50": `TimeItem-module__gap-50___qzg4r`,
	"flex1": `TimeItem-module__flex-1___XWyMH`,
	"flexNone": `TimeItem-module__flex-none___Ig1o4`,
	"flexColumn": `TimeItem-module__flex-column___yO3zF`,
	"flexRow": `TimeItem-module__flex-row___qeOxO`,
	"verticallyCentered": `TimeItem-module__vertically-centered___VOVh2`,
	"horizontallyCentered": `TimeItem-module__horizontally-centered___hQpfl`,
	"horizontallyEnd": `TimeItem-module__horizontally-end___NjbkR`,
	"verticallyStart": `TimeItem-module__vertically-start___o5RVb`,
	"spaceBetween": `TimeItem-module__space-between___HOZhw`,
	"flexWrap": `TimeItem-module__flex-wrap___d949x`,
	"height100": `TimeItem-module__height-100___i7P0v`,
	"width50": `TimeItem-module__width-50___xuR_X`,
	"width100": `TimeItem-module__width-100___QWRQA`,
	"cursorPointer": `TimeItem-module__cursor-pointer___ZxN7G`,
	"cursorNotAllowed": `TimeItem-module__cursor-not-allowed____vS1X`,
	"absoluteCentered": `TimeItem-module__absolute-centered___BR3Ki`,
	"absolute": `TimeItem-module__absolute___jUZ9D`,
	"relative": `TimeItem-module__relative___wiuzv`,
	"fixed": `TimeItem-module__fixed___wt1Gl`,
	"visible": `TimeItem-module__visible___N2vT8`,
	"invisible": `TimeItem-module__invisible___ecICf`,
	"col90": `TimeItem-module__col-90___UEDpv`,
	"colAuto": `TimeItem-module__col-auto___m8jK9`,
	"medicalTabs": `TimeItem-module__medical-tabs___qJuf_`,
	"medicalTableNew": `TimeItem-module__medical-table-new___y52OW`,
	"noPagination": `TimeItem-module__no-pagination___Z2QSG`,
	"medicalTableEmpty": `TimeItem-module__medical-table-empty____9rhD`,
	"iconBtn": `TimeItem-module__icon-btn___juRGO`,
	"searchIcon": `TimeItem-module__search-icon___iUnA3`,
	"disableSelect": `TimeItem-module__disable-select___GoakN`,
	"breakWord": `TimeItem-module__break-word___TwsAU`,
	"popupClearBtn": `TimeItem-module__popup-clear-btn___A9WBe`,
	"scrollMB20": `TimeItem-module__scroll-m-b-20___A6jF3`,
	"container": `TimeItem-module__container___eeVyg`,
	"input": `TimeItem-module__input___VQQez`
};
module.exports = ___CSS_LOADER_EXPORT___;
